import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=39132b1e&scoped=true&"
import script from "./Select.vue?vue&type=script&lang=ts&"
export * from "./Select.vue?vue&type=script&lang=ts&"
import style0 from "./Select.vue?vue&type=style&index=0&id=39132b1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39132b1e",
  null
  
)

export default component.exports